import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { text: "" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Developer")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            onClick: _ctx.enableMobileConsole,
            disabled: _ctx.mobileConsoleEnabled
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.mobileConsoleEnabled ?  'Mobile console active' : 'Activate mobile console'), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _hoisted_1,
          _createVNode(_component_ion_button, { onClick: _ctx.resetUserOnboarding }, {
            default: _withCtx(() => [
              _createTextVNode("Re-Onboard")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _hoisted_2,
          _createVNode(_component_ion_button, { onClick: _ctx.sendNotification }, {
            default: _withCtx(() => [
              _createTextVNode("Send custom notification")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _hoisted_3,
          _createVNode(_component_ion_button, { onClick: _ctx.errorPage }, {
            default: _withCtx(() => [
              _createTextVNode("Go to Error Page")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}